import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const ROWS = [{
  sin: 'Te despertás con la voz que te dice "no podés".',
  con: 'Arrancás el día con frases que te impulsan.'
}, {
  sin: 'Te comparás y te sentís menos.',
  con: 'Te enfocás en vos y soltás la mirada ajena.'
}, {
  sin: 'Te boicoteás sin entender por qué.',
  con: 'Detectás tu sabotaje y lo desarmás.'
}, {
  sin: 'Querés cambiar pero no sabés por dónde.',
  con: 'Tenés un plan de 21 días, paso a paso.'
}, {
  sin: 'Otro año hablándote como tu peor enemigo.',
  con: 'En 3 semanas, una nueva forma de pensar.'
}];
export function ComparisonTable() {
  return <section className="py-20 px-4 max-w-4xl mx-auto pt-[60px] pb-[60px]" data-id="element-36">
      <h2 className="font-serif text-3xl md:text-4xl text-brown font-bold text-center mb-12" data-id="element-37">
        Tu vida hoy vs. con el sistema
      </h2>

      <div className="bg-white rounded-3xl shadow-xl border border-gold/20 overflow-hidden mb-12" data-id="element-38">
        <div className="grid grid-cols-2 bg-brown text-cream font-sans font-bold text-sm md:text-base text-center" data-id="element-39">
          <div className="p-4 md:p-6 border-r border-white/10 opacity-70" data-id="element-40">
            SIN HACKEÁ TU REALIDAD
          </div>
          <div className="p-4 md:p-6 text-gold" data-id="element-41">CON HACKEÁ TU REALIDAD</div>
        </div>

        <div className="divide-y divide-cream" data-id="element-42">
          {ROWS.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="grid grid-cols-2 font-sans text-sm md:text-base" data-id="element-43">
              <div className="p-4 md:p-6 border-r border-cream flex items-start gap-3 text-brown/70 bg-cream/30" data-id="element-44">
                <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5 hidden md:block" data-id="element-45" />
                <p data-id="element-46">{row.sin}</p>
              </div>
              <div className="p-4 md:p-6 flex items-start gap-3 text-brown font-medium bg-gold/5" data-id="element-47">
                <Check className="w-5 h-5 text-gold shrink-0 mt-0.5 hidden md:block" data-id="element-48" />
                <p data-id="element-49">{row.con}</p>
              </div>
            </motion.div>)}
        </div>
      </div>

      <p className="font-serif text-xl text-center text-brown/80 max-w-2xl mx-auto italic" data-id="element-50">
        No hacer nada también tiene un precio: otro año entero siendo
        espectador. Ese es el más caro de todos.
      </p>
    </section>;
}